<template>
  <div style="background: #f9f9f9">
    <div class="userCenter flex">
      <!-- 左边列表 -->
      <div class="userCenter_left">
        <div
          class="userCenter_left_box"
          v-for="(items, index) in userServeList"
          :key="index"
        >
          <p class="userCenter_left_title">{{ items.title }}</p>
          <p
            v-for="(itemsName, indexs) in items.titleMess"
            :key="indexs"
            @click="getUserMessage(index, indexs)"
            :class="
              userServeIndex == index && userServeIndex2 == indexs
                ? 'active_p'
                : ''
            "
          >
            {{ itemsName.name }}
          </p>
        </div>
      </div>
      <!-- 右边信息 -->
      <div class="userCenter_right">
        <h4>基础信息</h4>
        <div class="flex userCenter_right_box">
          <!-- 上传头像 -->
          <div class="right_boxImg">
            <img :src="userInfo.avatar" alt="" class="" @click="handUserimg" />
            <input
              type="file"
              accept="image/*"
              @change="handleFile"
              class="hiddenInput"
            />
            <p>修改头像</p>
          </div>

          <div class="userCenter_right_mess">
            <p class="userCenter_right_name">EMMA</p>
            <div class="flex userCenter_right_con">
              <div class="flex userCenter_right_conN">
                <p class="conName">认证信息</p>
                <p class="userMessage">个人实名认证</p>
                <p class="userMessMore">详情</p>
              </div>
              <div class="flex">
                <p class="conName">登录账户</p>
                <p class="conMessage">185****5311</p>
              </div>
            </div>
            <div class="flex userCenter_right_con">
              <div class="flex userCenter_right_conN">
                <p class="conName">
                  昵&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;称
                </p>
                <p class="conMessage1">EMMA</p>

                <p class="userMessMore">
                  <i class="el-icon-edit-outline"></i> 修改
                </p>
              </div>
              <div class="flex">
                <p class="conName">注册时间</p>
                <p class="conMessage">2021-12-31</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {} from "../../../utils/interface";

export default {
  //   用户中心
  name: "userCenter",
  data() {
    return {
      userServeList: [
        {
          title: "用户服务",
          titleMess: [
            {
              name: "用户中心",
            },
            {
              name: "账号设置",
            },
            {
              name: "安全设置",
            },
            {
              name: "我的支付",
            },
            {
              name: "我的退款",
            },
            {
              name: "银行卡设置",
            },
          ],
        },
        {
          title: "认证中心",
          titleMess: [
            {
              name: "实名认证",
            },
            {
              name: "企业认证",
            },
          ],
        },
        {
          title: "企业管理",
          titleMess: [
            {
              name: "组织架构",
            },
            {
              name: "成员管理",
            },
          ],
        },
      ],
      userServeIndex: "0",
      userServeIndex2: "0",
      // 上传头像
      imageUrl: require("../../../assets/noneImg.png"),
      userInfo: {
        avatar:require("../../../assets/noneImg.png")
      },
    };
  },
  methods: {
    getUserMessage(i, is) {
      this.userServeIndex = i;
      this.userServeIndex2 = is;
    },
    // 上传头像
    handUserimg() {
      this.$el.querySelector(".hiddenInput").click();
    },
    // 将头像显示
    handleFile(e) {
      //获取当前点击事件的target元素对其进行兼容
      let $target = e.target || e.srcElement;
      //   取第一个元素
      let file = $target.files[0];
      /**
       * 使用FileReader对象，
       * web应用程序可以异步的读取存储在用户计算机上的文件(或者原始数据缓冲)内容，
       * 可以使用File对象或者Blob对象来指定所要处理的文件或数据。
       *  */
      var reader = new FileReader(); // //读取本地文件，以gbk编码方式输出
      reader.onload = (data) => {
        //成功读取后
        // console.log(data);
        let res = data.target || data.srcElement;
        // //读取完毕后输出结果
        this.userInfo.avatar = res.result;
      };
      reader.readAsDataURL(file);
    },
  },
};
</script>

<style scoped lang="less">
.blue {
  color: #1181ff;
}
.red {
  color: #d60000;
}
.userCenter {
  width: 1200px;
  margin: 0 auto;
  padding: 70px 0;
  .userCenter_left {
    width: 200px;
    text-align: center;
    margin-right: 34px;
    .userCenter_left_box {
      background: #fff;
      border-radius: 5px;
      font-size: 14px;
      margin-bottom: 10px;
    }
    p {
      height: 40px;
      line-height: 40px;
      border-bottom: 2px solid #f9f9f9;
      cursor: pointer;
    }
    .active_p {
      background: #e2efff;
    }
    .userCenter_left_title {
      cursor: default;
      color: #fff;
      border-radius: 5px 5px 0 0;
      background: #157efb;
      height: 50px;
      line-height: 50px;
      font-size: 17px;
    }
  }
  .userCenter_right {
    width: 966px;
    background: #fff;
    h4 {
      color: #157efb;
      padding: 20px 18px;
      border-bottom: 2px solid #f9f9f9;
    }
    .userCenter_right_box {
      padding: 30px 18px;
      // 上传头像
      .right_boxImg {
          width: 100px;
        position: relative;
        img {
          width: 100%;
          height: 100px;
          // border-radius: 50%;
        }
        .hiddenInput {
          display: none;
        }
        p {
          position: absolute;
          bottom: 5px;
          width: 100%;
          font-size: 12px;
          background: rgba(255, 255, 255, 0.68);
          text-align: center;
          color: #777777;
        }
      }

      .userCenter_right_mess {
        margin-left: 20px;
        .userCenter_right_name {
        }
        .userCenter_right_con {
          color: #595959;
          font-size: 14px;
          margin-top: 18px;

          .userCenter_right_conN {
            margin-right: 70px;
            align-items: center;
            width: 230px;
            // justify-content: space-between;
          }
          .conName {
            margin-right: 16px;
          }
          .userMessage {
            font-size: 12px;
            background: #bbd9fe;
            color: #157efb;
            padding: 4px 0;
            margin-right: 16px;
            width: 101px;
            text-align: center;
          }
          .userMessMore {
            font-size: 12px;
            color: #157efb;
            cursor: pointer;
            text-align: right;
          }
          .conMessage {
            font-size: 13px;
          }
          .conMessage1 {
            font-size: 13px;
            margin-right: 16px;
            width: 86px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/registeredLogin/enterpriseCenter/index.vue